import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Partials/DynamicPortfolio.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Partials/Showcase.tsx");
